// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as App_Modal$DvmAdminFrontendFr from "../../../common/components/App_Modal.bs.js";
import * as App_Button$DvmAdminFrontendFr from "../../../common/components/button/App_Button.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../intl/Intl_Utils.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../common/utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../common/App_Typography.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../common/components/App_LabeledText.bs.js";
import * as Messages_Button$DvmAdminFrontendFr from "../../../intl/messages/Messages_Button.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../common/types/App_Types_Result.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../context/user/User_Types_Utils.bs.js";
import * as Pool_Expenses_Api$DvmAdminFrontendFr from "../Pool_Expenses_Api.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../../common/components/App_OverlaySpinner.bs.js";
import * as App_TextFieldFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_TextFieldFormInput.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";
import * as Pool_Expenses_Modal_Api$DvmAdminFrontendFr from "./Pool_Expenses_Modal_Api.bs.js";
import * as Pool_Expenses_Update_Form$DvmAdminFrontendFr from "./Pool_Expenses_Update_Form.bs.js";

function Pool_Expenses_Update_Modal(Props) {
  var onClose = Props.onClose;
  var row = Props.row;
  var onOk = Props.onOk;
  var tableType = Props.tableType;
  var intl = ReactIntl.useIntl();
  var alert = ReactAlert.useAlert();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResult = match$2[1];
  var result = match$2[0];
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setSaveResult = match$3[1];
  var saveResult = match$3[0];
  React.useEffect((function () {
          if (selectedRole === /* RMPC */9) {
            Pool_Expenses_Api$DvmAdminFrontendFr.fetchPoolExpenses(undefined, userManager, setResult, "?limit=1&offset=0&filter=periodID=" + row.periodID + ";year=" + row.year + "", selectedRole, /* RMPC */0);
          }
          
        }), []);
  React.useEffect((function () {
          if (typeof saveResult === "number") {
            saveResult === /* NotStarted */0;
          } else if (saveResult.TAG === /* Ok */0) {
            Utils_Alert$DvmAdminFrontendFr.success(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {}));
            Curry._1(onOk, undefined);
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: saveResult._0
                      }
                    }));
          }
        }), [saveResult]);
  var form = Pool_Expenses_Update_Form$DvmAdminFrontendFr.Form.useForm(Pool_Expenses_Update_Form$DvmAdminFrontendFr.initialState, {
        selectedRole: selectedRole,
        initialAmount: Belt_Option.getWithDefault(row.allocatedResources, 0.0),
        fetchResult: result
      }, (function (output, submissionCallbacks) {
          Pool_Expenses_Modal_Api$DvmAdminFrontendFr.editRow(userManager, setSaveResult, submissionCallbacks, selectedRole, row, output.amount, tableType);
        }));
  var tmp = {
    onChange: Curry._1(form.updateAmount, (function (param, amount) {
            return {
                    amount: amount
                  };
          })),
    value: form.input.amount,
    label: Messages_Pool_Expenses$DvmAdminFrontendFr.amountToAdd,
    required: /* OnlyLabel */1,
    inputType: "number"
  };
  var tmp$1 = selectedRole === /* RMPC */9 ? undefined : form.amountResult;
  if (tmp$1 !== undefined) {
    tmp.validationResult = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement(App_Modal$DvmAdminFrontendFr.make, {
              open: true,
              onClose: onClose,
              title: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.modifyPoolExpense),
              minWidth: "600px",
              children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                    show: App_Types_Result$DvmAdminFrontendFr.isPending(saveResult),
                    children: React.createElement("form", {
                          onSubmit: (function ($$event) {
                              $$event.preventDefault();
                              Curry._1(form.submit, undefined);
                            })
                        }, React.createElement(Core.Grid, {
                              alignItems: "center",
                              children: null,
                              container: true,
                              direction: "column",
                              spacing: 4
                            }, React.createElement(Core.Grid, {
                                  children: null,
                                  container: true,
                                  item: true,
                                  justifyContent: "space-between",
                                  spacing: 2
                                }, React.createElement(Core.Grid, {
                                      children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                            label: Messages_Common$DvmAdminFrontendFr.year,
                                            children: row.year
                                          }),
                                      item: true
                                    }), React.createElement(Core.Grid, {
                                      children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                            label: Messages_Common$DvmAdminFrontendFr.period,
                                            children: row.periodID
                                          }),
                                      item: true
                                    }), React.createElement(Core.Grid, {
                                      children: tableType ? React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                              label: Messages_Pool_Expenses$DvmAdminFrontendFr.mrIpnLabel,
                                              children: Belt_Option.getWithDefault(row.mr, "-")
                                            }) : React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                              label: Messages_Pool_Expenses$DvmAdminFrontendFr.rmpcIpnLabel,
                                              children: Belt_Option.getWithDefault(row.rmpc, "-")
                                            }),
                                      item: true
                                    }), React.createElement(Core.Grid, {
                                      children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                            label: Messages_Common$DvmAdminFrontendFr.startDate,
                                            children: Belt_Option.mapWithDefault(row.startDate, "-", (function (param) {
                                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                                  }))
                                          }),
                                      item: true
                                    }), React.createElement(Core.Grid, {
                                      children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                            label: Messages_Common$DvmAdminFrontendFr.endDate,
                                            children: Belt_Option.mapWithDefault(row.endDate, "-", (function (param) {
                                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                                  }))
                                          }),
                                      item: true
                                    })), React.createElement(Core.Grid, {
                                  children: null,
                                  container: true,
                                  item: true,
                                  justifyContent: "space-between",
                                  spacing: 1
                                }, selectedRole === /* RMPC */9 ? React.createElement(Core.Grid, {
                                        children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                              label: Messages_Pool_Expenses$DvmAdminFrontendFr.availableExpenses,
                                              children: App_Types_Result$DvmAdminFrontendFr.mapWithDefault(result, "-", (function (x) {
                                                      return Belt_Option.mapWithDefault(Belt_List.get(x.content, 0), "-", (function (x) {
                                                                    return Belt_Option.mapWithDefault(x.resourcesToAllocate, "-", (function (prim) {
                                                                                  return String(prim);
                                                                                }));
                                                                  }));
                                                    }))
                                            }),
                                        item: true
                                      }) : null, React.createElement(Core.Grid, {
                                      children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                            label: Messages_Pool_Expenses$DvmAdminFrontendFr.allocatedResources,
                                            children: Belt_Option.mapWithDefault(row.allocatedResources, "-", (function (prim) {
                                                    return String(prim);
                                                  }))
                                          }),
                                      item: true
                                    }), React.createElement(Core.Grid, {
                                      children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, tmp),
                                      item: true
                                    })), (User_Types_Utils$DvmAdminFrontendFr.isAdmin(selectedRole) || selectedRole === /* DPR */10) && tableType === /* MR */1 ? React.createElement(Core.Grid, {
                                    children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                          color: "error",
                                          children: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.dprAllocationReminder),
                                          variant: "body"
                                        }),
                                    item: true
                                  }) : null, selectedRole === /* RMPC */9 ? Belt_Option.mapWithDefault(form.amountResult, null, (function (x) {
                                      if (x.TAG === /* Ok */0) {
                                        return null;
                                      } else {
                                        return React.createElement(Core.Grid, {
                                                    children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                                          color: "error",
                                                          style: {
                                                            textAlign: "center",
                                                            width: "500px"
                                                          },
                                                          children: intl.formatMessage(x._0),
                                                          variant: "body"
                                                        }),
                                                    item: true
                                                  });
                                      }
                                    })) : null, React.createElement(Core.Grid, {
                                  children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                        label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.confirm),
                                        color: "primary",
                                        size: "medium",
                                        type_: "submit"
                                      }),
                                  item: true
                                })))
                  })
            });
}

var Api;

var Form;

var make = Pool_Expenses_Update_Modal;

export {
  Api ,
  Form ,
  make ,
}
/* react Not a pure module */
